import { QueryClient } from '@tanstack/react-query';
import mapCartMutationResponse from '../../utils/map-cart-mutation-response';
import { cartKeys } from './query-keys';

const syncCartCache = (queryClient: QueryClient, rawCart: Cart) => {
    const cart = mapCartMutationResponse(rawCart);

    queryClient.setQueryData<Cart>(cartKeys.view(), (previous) => (previous ? { ...previous, ...cart } : previous));
};

export default syncCartCache;
